import React, { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryBase from "../components/EntryBase";
import EntryGrid from "../components/EntryGrid";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntrySetting from "../components/EntrySetting";
import DataTree from "../components/DataTree";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {
    isEmpty, getformid, getcontroller, getsubkey, getWindowDimensions, setglobaldata, 
    NumConv, DicVal, getglobaldata, DeepCopy, initializedata, RandomKey, Savestorage, Getstorage, 
    isEnabled,  GetRound,  FormatDate, GetDesitRound 
} from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entryformlock, entrytriggercall,readonly,reports  } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));


export const SaleOrderP = props => {

    const panelsdef = [];
    const G_id = { BASE: "0", ROW: "1", IMAGE: "pic",  FILE: "file", TOTAL:"T1" }
    const primarykeys = ["d_recv_p_no", "d_recv_p_row_no"];

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const entrylock = useSelector(state => state.form.entryformlock);
    const warndescription = useSelector(state => state.form.warndiscription);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const themestyle = useSelector(state => state.form.themestyle);
    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const apiRefrow = useRef({ grid: undefined, column: undefined });
    const apiReftotal = useRef({ grid: undefined, column: undefined });
    const apirow = apiRefrow.current;
    const apitotal = apiReftotal.current;
    const CalcParam = useRef({taxrate:0.1, amtround:1, taxround:1});
    const locationstate = useRef(null);    //遷移State

    const entrydataRef = useRef(null);    //基本情報データ
    const rowsRef = useRef(null);         //受注明細データ
    const colRef = useRef(null);          //受注明細列情報  
    const totalRef = useRef(null);        //受注合計データ
    const totalcolRef = useRef(null);   　//受注合計列情報  
    const imageRef = useRef(null);        //画像
    const fileRef = useRef(null);         //ファイル  

    const modifyRef = useRef(false);    //変更フラグ
    const menuinfo = useSelector(state => state.form.menuinfo);
    const formstatus = useSelector(state => state.form.status);
    const formlock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [rowDragManaged, setrowDragManaged] = useState(true);
    const [update, setUpdata] = useState(false);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const search = useLocation().search;

    const dispatch = useDispatch();
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const formid = getformid("SaleOrderP", props.location.search);
    const controller = getcontroller("SaleOrderP", props.location.search);
    const subkey = getsubkey(props.location.search);
    const reportsRef = useRef(null);

    const actionurl = {
        "insert": "saleorderp/Insert",
        "update": "saleorderp/Update",
        "delete": "saleorderp/Delete",
        "saveas": "saleorderp/SaveAs",
        "storageadd": "saleorderp/AddStorage",
        "storagerowdel": "saleorderp/StorageRowdel",
       "upload": "saleorderp/Upload",
    }
    const navmenu = [
        { status: "ENTRY FORM", menuid: "formupload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "ENTRY FORM", menuid: "sep" },
        { status: "ENTRY FORM", menuid: "datatree", icon: "account_tree", label: "Data Tree" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title:"現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "upload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "listdatatree", icon: "account_tree", label: "Data Tree" },
    ]

    //動作抑止
    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "1", action: "INSERT" }
    ];

    function rerender() {
        setUpdata(update ? false : true);
    }
    function statusKey(id) {
        return formid + "entry_" + id;
    }

    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    function FileDropClose() {
        setIsDragActive(false);
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(reports(data.reports));
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    reportsRef.current = data.reports;
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    //列情報初期化
                    colRef.current = null;
                    totalcolRef.current = null;

                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
                }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);


    useEffect(() => {
        if (isEmpty(entrydataRef.current)) return;
        if (formstatus === "COPY FORM") {
            entrydataRef.current["d_recv_p_no"] = "";
            entrydataRef.current["d_recv_p_createac"] = "";
            entrydataRef.current["d_recv_p_createdate"] = "";
            entrydataRef.current["d_recv_p_updateac"] = "";
            entrydataRef.current["d_recv_p_update"] = "";
            //受入ロック解除
            for (let i = 0; i < rowsRef.current.length; i++) {
                rowsRef.current[i]["lockrow"] = false;
            }
            setrowDragManaged(true);    //行入れ替え可
            setsliplock(false);
            rerender();
        }
    }, [formstatus]);

    //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                clearform();
                if (entrydataRef.current === null) entrydataRef.current = {};
                AcceptAction(locationstate.current.acceptno, locationstate.current.accepttype);
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }

    function setsliplock(value) {
        dispatch(entryformlock(value));
    }

    function onFirstDataRendered(param, id) {
        if (id === G_id.ROW) {
            apiRefrow.current.grid = param.api;
            apiRefrow.current.column = param.columnApi;
        }
        if (id === G_id.TOTAL) {
            apiReftotal.current.grid = param.api;
            apiReftotal.current.column = param.columnApi;
            if (isEmpty(locationstate.current)) {
            //    RowDataChanged();
            } else {
                //遷移表示
                callshow();
            }
        }
    }

    function MenuQueryAction(action, param) {
        if (action === 'delete' && formstatus === "UPDATE") {
            if (param.tabvalue !== '0') {
                fnc.current.warnmsg("このシートのデータは削除できません");
                return false;
            }
        }
        return true;
    }
    function MenuAction(action, finallycallback, param) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") {
            clearform(true);
        }
        if (action === 'linkfield') {
            switch (finallycallback.table) {
                case "d_recv_p":
                    let type = "100";
                    let col = textfields.find(e => e.columnid === finallycallback.field);
                    if (col !== undefined) {
                        type = col.type;
                        let key = finallycallback.field + "_" + type;
                        document.getElementById(key).focus();
                        document.getElementById(key).select();
                    }
                    Jump(G_id.BASE, type);
                    break;
                case "d_recv_p_row":
                    Jump(G_id.ROW);
                    AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, apirow.grid);
                    break;
                default:
                    break;
            }
        }
        if (reportsRef.current.some(e => e.id === action)) {   //帳票
            let code = [];
            if (formstatus === "ENTRY FORM") {
                code = [edittingcode];
            } else {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('common/Printout', { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
        if (action === 'datatree') {
            DataTreeOpen(edittingcode);
        }
        if (action === 'listdatatree') {
            for (let i = 0; i < primarykeys.length; i++) {
                if (primarykeys[i] in param[0]) {
                    setedittingcode(param[0][primarykeys[i]]);
                    DataTreeOpen(param[0][primarykeys[i]]);
                    return;
                }
            }
        }
        function DataTreeOpen(code) {
            fnc.current.postaxios('saleorderp/GetDataTree', { "code": code },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        fnc.current.datatreeopen(data.list);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata", data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        clearform(code==="");
        //データ読み込み
        LoadData(code);
        return true;
    }
    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('saleorderp/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            if (row !== null) {
                                if ("d_recv_p_memo" in row) data.data.d_recv_p_memo = row.d_recv_p_memo;
                                if ("d_recv_p_sticky" in row) data.data.d_recv_p_sticky = row.d_recv_p_sticky;
                                if ("d_recv_p_mytags" in row) data.data.d_recv_p_mytags = row.d_recv_p_mytags;
                            }
                            fnc.current.margeMaster(data.master);
                            entrydataRef.current = data.data;
                            rowsRef.current = data.row;
                            imageRef.current = data.images;
                            fileRef.current = data.files;
                            dispatch(setimagelist(data.images));
                            var totalfields = ["d_recv_p_qty", "d_recv_p_amount", "d_recv_p_tax", "d_recv_p_taxinamt", "d_recv_p_taxkind",
                                "d_recv_p_rate", "d_recv_p_currencyamt"]
                            var totalcols = columninfo.filter(e => e.logpid === "T1");
                            for (let i = 0; i < totalcols.length; i++) {
                                if (totalfields.indexOf(totalcols[i].columnid) === -1)
                                    totalfields.push(totalcols[i].columnid);
                            }
                            var total = { rowid: "TOTAL", grip: "計" };
                            for (let i = 0; i < totalfields.length; i++) {
                                total[totalfields[i]] = data.data[totalfields[i]];
                            }
                            totalRef.current = [total];
                            let tax = (NumConv(data.data["d_recv_p_taxrate"]) / 100).toString();
                            CalcParam.current = {
                                taxrate: tax, amtround: data.data["m_clt_roundamt"], taxround: data.data["m_clt_roundtax"],
                                taxdate: FormatDate(data.data["d_recv_p_date"]), cltcode: data.data["d_recv_p_client"],
                                rate: data.data["m_clt_prate"]
                            };
                            taxApply(tax, data.taxs, true);

                            //受入済の場合行入れ替え不可
                            let lock = data.row.some(e => e.lockrow);
                            setrowDragManaged(!lock);
                            setsliplock(data.data["d_recv_p_lock"] !== "0");   //伝票ロックか
                            rerender();
                        }
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                }
            }
        )
    }

    //リストValueChange
    function ListCellChange(params, columninfo) {
        //簡易計算処理
        var data = null;
        if (params.colDef.field === "d_recv_p_row_qty") {
            if (columninfo.some(e => e.columnid === "d_recv_p_row_amount") && columninfo.some(e => e.columnid === "d_recv_p_row_price")) {
                let value = NumConv(params.newValue) * NumConv(DicVal(params.data, "d_recv_p_row_price", 0));
                value = GetRound(value, 1);   //四捨五入暫定
                data = { d_recv_p_row_amount: value };
                if (columninfo.some(e => e.columnid === "d_recv_p_row_currencyamt") && columninfo.some(e => e.columnid === "d_recv_p_row_currency")) {
                    let value = NumConv(params.newValue) * NumConv(DicVal(params.data, "d_recv_p_row_currency", 0));
                    let col = columninfo.find(e => e.columnid === "d_recv_p_row_currencyamt");
                    if (!isEmpty(col)) {
                        value = GetDesitRound(value, 1, col.decimalplace);   //四捨五入暫定
                    }
                    data["d_recv_p_row_currencyamt"] = value;
                }
            }
        }
        if (params.colDef.field === "d_recv_p_row_retailprice" || params.colDef.field === "d_recv_p_row_rate") {
            if (columninfo.some(e => e.columnid === "d_recv_p_row_retailprice") && columninfo.some(e => e.columnid === "d_recv_p_row_rate") && columninfo.some(e => e.columnid === "d_recv_p_row_price")) {
                var value = 0;
                //単価＝上代×掛け率
                if (params.colDef.field === "d_recv_p_row_retailprice")
                    value = NumConv(params.newValue) * (NumConv(DicVal(params.data, "d_recv_p_row_rate", 0) / 100));
                else
                    value = (NumConv(params.newValue) / 100) * NumConv(DicVal(params.data, "d_recv_p_row_retailprice", 0));
                let price = GetRound(value, 1);   //四捨五入暫定
                value = price * NumConv(DicVal(params.data, "d_recv_p_row_qty", 0));
                value = GetRound(value, 1);       //四捨五入暫定
                data = { d_recv_p_row_price: price, d_recv_p_row_amount: value };
            }
        }
        if (params.colDef.field === "d_recv_p_row_price") {
            if (columninfo.some(e => e.columnid === "d_recv_p_row_amount") && columninfo.some(e => e.columnid === "d_recv_p_row_qty")) {
                let value = NumConv(params.newValue) * NumConv(DicVal(params.data, "d_recv_p_row_qty", 0));
                value = GetRound(value, 1);   //四捨五入暫定
                data = { d_recv_p_row_amount: value };
            }
        }
        if (params.colDef.field === "d_recv_p_row_currency") {
            if (columninfo.some(e => e.columnid === "d_recv_p_row_currencyamt") && columninfo.some(e => e.columnid === "d_recv_p_row_qty")) {
                let value = NumConv(params.newValue) * NumConv(DicVal(params.data, "d_recv_p_row_qty", 0));
                let col = columninfo.find(e => e.columnid === "d_recv_p_row_currencyamt");
                if (!isEmpty(col)) {
                    value = GetDesitRound(value, 1, col.decimalplace);   //四捨五入暫定
                }
                data = { d_recv_p_row_currencyamt: value };
            }
        }
        return data;
    }
    //行データ変更処理
    function ListRowChange(data, columninfo) {
        //金額＝数量×単価
        if (columninfo.some(e => e.columnid === "d_recv_p_row_amount") && columninfo.some(e => e.columnid === "d_recv_p_row_qty") && columninfo.some(e => e.columnid === "d_recv_p_row_price")) {
            let value = NumConv(DicVal(data, "d_recv_p_row_price", 0)) * NumConv(DicVal(data, "d_recv_p_row_qty", 0));
            value = GetRound(value, 1);   //四捨五入暫定
            data["d_recv_p_row_amount"] = value;
        }
        //外貨金額＝数量×外貨単価
        if (columninfo.some(e => e.columnid === "d_recv_p_row_currencyamt") && columninfo.some(e => e.columnid === "d_recv_p_row_qty") && columninfo.some(e => e.columnid === "d_recv_p_row_currency")) {
            let value = NumConv(DicVal(data, "d_recv_p_row_currency", 0)) * NumConv(DicVal(data, "d_recv_p_row_qty", 0));
            let col = columninfo.find(e => e.columnid === "d_recv_p_row_currencyamt");
            if (!isEmpty(col)) {
                value = GetDesitRound(value, 1, col.decimalplace);   //四捨五入暫定
            }
            data["d_recv_p_row_currencyamt"] = value;
        }
    }

    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (!edit) return edit;
        if (status === "INSERT") {
            if (params.colDef.field === "d_recv_p_mytags" ||
                params.colDef.field === "d_recv_p_sharetags" ||
                params.colDef.field === "d_recv_p_sticky" ||
                params.colDef.field === "d_recv_p_memo") {
                return false;
            }
        }
        if (status === "UPDATE") {
            if (DicVal(params.data, "d_recv_p_lock", "") === "1") return false;    //伝票ロック
            if (params.colDef.field === "d_recv_p_row_prodno" ||
                params.colDef.field === "d_recv_p_row_colno" ||
                params.colDef.field === "d_recv_p_row_colnm" ||
                params.colDef.field === "d_recv_p_row_size" ||
                params.colDef.field === "d_recv_p_row_sizenm") {
                return false;   //編集不可　判定困難なため暫定
            }
        }
        return edit;
    }

    //明細カラム定義
    function ColdefSpecial(column) {
        if (formstatus !== "ENTRY FORM") return;
        //受入データがある場合編集不可
        if (column.field === "d_recv_p_row_prodno" ||
            column.field === "d_recv_p_row_colno" ||
            column.field === "d_recv_p_row_colnm" ||
            column.field === "d_recv_p_row_size" ||
            column.field === "d_recv_p_row_sizenm" ) {
            column.editable = function (params) {
                if (params.context.entrylock) return false;
                else
                    return !isEnabled(params.node.data["lockrow"]);
            }
            column.cellStyle = function (params) {
                if (!params.context.entrylock && isEnabled(params.node.data["lockrow"])) {
                    return { backgroundColor: '#eee' };
                } else {
                    return null;
                }
            }
        }
    }

    function Save(finallycallback) {
        storeRowData();
        let row = rowsRef.current;
        if (!AGRef.current.ExistValidRow(rowsRef.current, columninfo, colRef.current)) {
            fnc.current.warnmsg("有効な受注明細が存在しません");
            return;
        }
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        Apply();

        function Apply() {
            if (isEmpty(entrydataRef.current)) entrydataRef.current = {};
            if (!isEmpty(totalRef.current)) {
                for (let key in totalRef.current[0]) {
                    if (key === "rowid") continue;
                    entrydataRef.current[key] = totalRef.current[0][key]
                }
            }
            const paramdata = {
                "controller": formid,
                "data": entrydataRef.current,
                "rowdata": row,
                "images": imageRef.current,
                "files": fileRef.current,
                "colinfo": columninfo,
                "code": edittingcode
            }
            fnc.current.postaxios(formstatus === "ENTRY FORM" ? "saleorderp/UpdateEntry" : "saleorderp/InsertEntry", paramdata,
                {
                    onSuccess: function (data) {
                        if (data.warning.length === 0) {
                            fnc.current.modify(false);
                            let code = data.request;
                            if (formstatus !== "ENTRY FORM") {
                                entrydataRef.current["d_recv_p_no"] = data.request;
                                setedittingcode(data.request);
                                dispatch(changestatus("ENTRY FORM"));
                            }
                            if (newfiles.length !== 0) {        //v1.4
                                //新規ファイルアップロード
                                cfFileUpload("saleorderp", code, newfiles, fnc, () => LoadData(code));
                            } else {
                                fnc.current.success();
                                if (formstatus === "ENTRY FORM") {
                                    data.data['rowid'] = Getrowid();    //更新行キー
                                    finallycallback(data.data);
                                }
                                LoadData(code);     //再表示
                            }
                        }
                        else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                        fnc.current.wait(false);
                    },
                    errmsg: "登録に失敗しました"
                }
            )
        }
    }

   function Delete(finallycallback) {
       const param = {
           rowdata: [{ "rowid": edittingcode }],
           controller: controller
       }
        fnc.current.postaxios("saleorderp/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }

    //受入処理
    function AcceptAction(value, type) {
        fnc.current.postaxios('saleorderp/GetAccept', { "code": value, "type": type, "colinfo": columninfo },
            {
                onSuccess: function (data) {
                    clearform();
                    fnc.current.margeMaster(data.master);
                    entrydataRef.current = data.data;
                    rowsRef.current = data.rowdata;
                    var totalfields = ["d_recv_p_qty", "d_recv_p_amount", "d_recv_p_tax", "d_recv_p_taxinamt", "d_recv_p_taxkind",
                        "d_recv_p_rate", "d_recv_p_currencyamt"];     //必須
                    var totalcols = columninfo.filter(e => e.logpid === "T1");
                    for (let i = 0; i < totalcols.length; i++) {
                        if (totalfields.indexOf(totalcols[i].columnid) === -1)
                            totalfields.push(totalcols[i].columnid);
                    }
                    var total = { rowid: "TOTAL", grip: "計" };
                    for (let i = 0; i < totalfields.length; i++) {
                        total[totalfields[i]] = data.data[totalfields[i]];
                    }
                    totalRef.current = [total];
                    CalcParam.current = {
                        taxrate: data.data["taxrate"], amtround: data.data["m_clt_roundamt"], taxround: data.data["m_clt_roundtax"],
                        taxdate: FormatDate(data.data["d_recv_p_date"]), splrcode: data.data["d_recv_p_client"],
                        rate: data.data["m_clt_prate"]
                    };
                    setrowDragManaged(false);
                    setsliplock(false);

                    RowDataChanged();
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    fnc.current.warnmsg("受入データが存在しません");
                    fnc.current.wait(false);
                },
                errmsg: "処理に失敗しました"
            }
        )
    }

    //行挿入前イベント
    function QueryInsertRow(row) {
        if (formstatus === "ENTRY FORM") {
            if (isEnabled(row.data.lockrow)) {
                fnc.current.warnmsg("この明細は受入済の為行挿入できません");
                return false;
            }
            //指定行以降に受け入れ済が存在する場合エラー
            for (let i = row.rowIndex + 1; i < rowsRef.current.length; i++) {
                if (isEnabled(rowsRef.current[i]["lockrow"])) {
                    fnc.current.warnmsg("受入済明細が存在する為行挿入できません");
                    return false;
                }
            }
        }
        return true;
    }
    //行削除前イベント
    function QueryRemoveRow(rows) {
        if (formstatus === "ENTRY FORM") {
            for (let i = 0; i < rows.length; i++) {
                if (isEnabled(rows[i].lockrow)) {
                    if (rows.length === 1) fnc.current.warnmsg("この明細は受入済の為行削除できません");
                    else fnc.current.warnmsg("受入済の明細が含まれている為行削除できません");
                    return false;
                }
            }
        }
        return true;
    }

    //Basic Data Change
    function ValueChanged(id, value) {
       if (id === "d_recv_p_client") {  //販売先
           if (value === CalcParam.current.cltcode) return;
           CalcParam.current.cltcode = value;
            if (isEmpty(value)) {
                CalcParam.current.amtround = 1;
                CalcParam.current.taxround = 1;
                CalcParam.current.rate = 100;
                totalRef.current[0]["d_recv_p_taxkind"] = "0";
                settaxkind();
                RowDataChanged(false, true);   //再計算
                return;
            }
            let data = fnc.current.getMaster("m_clt", value);
            if (!isEmpty(data)) {
                if ("m_clt_roundamt" in data && "m_clt_roundtax" in data && "m_clt_taxkind" in data && "m_clt_prate" in data) {
                    CalcParam.current.amtround = data["m_clt_roundamt"];
                    CalcParam.current.taxround = data["m_clt_roundtax"];
                    CalcParam.current.rate = data["m_clt_prate"];
                    totalRef.current[0]["d_recv_p_taxkind"] = data["m_clt_taxkind"];
                    settaxkind();
                    RowDataChanged(false, true);   //再計算
                    return;
                }
            }
            //販売先データ取得
            fnc.current.getMasterdata("m_clt", value, "",
                [
                    { columnid: "amtround", dbcolumn: "m_clt_roundamt" },
                    { columnid: "taxround", dbcolumn: "m_clt_roundtax" },
                    { columnid: "taxkind", dbcolumn: "m_clt_taxkind" },
                    { columnid: "rate", dbcolumn: "m_clt_prate" },
                ], null, (data) => cltApply(data))
        }
        if (id === "d_recv_p_date") {  //受注日
            if (value === CalcParam.current.taxdate) return;
            entrydataRef.current[id] = value;
            CalcParam.current.taxdate = value;
            fnc.current.getTaxrate(value, (tax, taxs) => taxApply(tax,taxs));
        }
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
        function cltApply(data) {
            if (isEmpty(data)) {
                CalcParam.current.amtround = 1;
                CalcParam.current.taxround = 1;
                CalcParam.current.rate = 100;
                totalRef.current[0]["d_recv_p_taxkind"] = "0";
                settaxkind();
            } else {
                fnc.current.setMaster(data);
                CalcParam.current.amtround = data["m_clt_roundamt"];
                CalcParam.current.taxround = data["m_clt_roundtax"];
                CalcParam.current.rate = data["m_clt_prate"];
                totalRef.current[0]["d_recv_p_taxkind"] = data["m_clt_taxkind"];
                settaxkind();
            }
            RowDataChanged(false, true);   //再計算
        }
        function settaxkind() {
            if (EmptyPanel(G_id.TOTAL)) return;
            if (isEmpty(apitotal.grid)) return;
            let rowNode = apitotal.grid.getRowNode("TOTAL");
            if (!isEmpty(rowNode)) {
                rowNode.setDataValue("d_recv_p_taxkind", totalRef.current[0]["d_recv_p_taxkind"]);
            }
        }
    }
    function taxApply(tax, taxs, formatonly, force) {
        if (isEnabled(force)) CalcParam.current.taxrate = tax;
        if (CalcParam.current.taxrate !== tax) {
            let rate = NumConv(CalcParam.current.taxrate) * 100;
            let exist = false;
            for (let key in taxs) {
                if (taxs[key] === rate.toString()) {
                    exist = true; break;
                }
            }
            if (!exist) CalcParam.current.taxrate = tax;
            else tax = CalcParam.current.taxrate;
        }
        var taxid = columninfo.find(e => e.columnid === "d_recv_p_taxrate");
        if (!isEmpty(taxid)) {
            var newtax = "";
            var newoptions = [];
            for (let key in taxs) {
                newoptions.push({ code: taxs[key], name: "" });
                newtax += taxs[key] + ",";
            }
            var oldtax = "";
            for (let i = 0; i < taxid.options.length; i++) {
                oldtax += taxid.options[i].code + ",";
            }
            if (oldtax !== newtax && !isEmpty(totalcolRef.current)) {
                taxid.options = newoptions;
                var target = totalcolRef.current.find(e => e.field === "d_recv_p_taxrate");
                if (!isEmpty(target)) {
                    target.colinfo = taxid;
                }
            }
        }
        if (isEnabled(formatonly)) return;
        totalRef.current[0]["d_recv_p_taxrate"] = (tax * 100).toString();
        RowDataChanged();   //再計算
    }
    //Total Data Change
    function TotalValueChange(params) {
        if (params.column.colId === "d_recv_p_taxrate") {
            if (NumConv(params.value) === 0) {  //選択肢以外の値が指定された場合
                let rowNode = apitotal.grid.getRowNode("TOTAL");
                totalRef.current[0]["d_recv_p_taxrate"] = (CalcParam.current.taxrate * 100).toString();
                if (!isEmpty(rowNode)) rowNode.setDataValue("d_recv_p_taxrate", CalcParam.current.taxrate * 100);
                return;
            }
            CalcParam.current.taxrate = NumConv(params.value) / 100;
            RowDataChanged();
        }
        if (params.column.colId === "d_recv_p_taxkind") {
            RowDataChanged();
        }
        if (params.column.colId === "d_recv_p_rate") { //レート
            RowDataChanged(true);
        }
    }
    //Grid Data Change
    function ChangeRowValue(params) {
        storeRowData(G_id.Row);
        let rowidx = params.node.rowIndex;
        if (params.column.colId === "d_recv_p_row_prodno") {
            //C/#、サイズクリア
            rowsRef.current[rowidx]["d_recv_p_row_colno"] = "";
            rowsRef.current[rowidx]["d_recv_p_row_colnm"] = "";
            rowsRef.current[rowidx]["d_recv_p_row_size"] = "";
            rowsRef.current[rowidx]["d_recv_p_row_sizenm"] = "";
            let node = apiRefrow.current.grid.getDisplayedRowAtIndex(rowidx);
            if (!isEmpty(node)) {
                node.setData(rowsRef.current[rowidx]);
            }
        }
        if (params.column.colId === "d_recv_p_row_qty" || params.column.colId === "d_recv_p_row_price" ||
            params.column.colId === "d_recv_p_row_retailprice" || params.column.colId === "d_recv_p_row_rate") {
            RowDataChanged(false, false, params.column.colId);
        }
        if (params.column.colId === "d_recv_p_row_currency") { //外貨単価
            RowDataChanged(true);
        }
    }
    function RowValueChanged(colid, targets) {
        if (columninfo.some(e => e.columnid === "d_recv_p_row_rate")) {
             //掛率初期値セット
            for (let i = 0; i < targets.length; i++) {
                if (NumConv(DicVal(targets[i], "d_recv_p_row_rate", 0)) === 0) {
                    for (let j = 0; j < rowsRef.current.length; j++) {
                        if (rowsRef.current[j]["rowid"] === targets[i]["rowid"]) {
                            rowsRef.current[j]["d_recv_p_row_rate"] = CalcParam.current.rate;
                            if (("d_recv_p_row_retailprice" in rowsRef.current[j]) ) {
                                //単価＝上代×掛け率
                                let price = NumConv(rowsRef.current[j]["d_recv_p_row_retailprice"]) * (CalcParam.current.rate / 100);
                                price = GetRound(price, CalcParam.current.amtround);
                                rowsRef.current[j]["d_recv_p_row_price"] = price;
                            }
                            break;
                        }
                    }
                }
            }
        }
        if (colid === "d_recv_p_row_prodno") {
            for (let i = 0; i < targets.length; i++) {
                //C/#、サイズクリア
                targets[i]["d_recv_p_row_colno"] = "";
                targets[i]["d_recv_p_row_colnm"] = "";
                targets[i]["d_recv_p_row_size"] = "";
                targets[i]["d_recv_p_row_sizenm"] = "";
                var node = apiRefrow.current.grid.getRowNode(targets[i].rowid);
                if (!isEmpty(node)) {
                    node.setData(targets[i]);
                }
            }
        }
        RowDataChanged();
    }
    //Grid Row Data Change
    function RowDataChanged(priceconv, clientchg, colid) {
        if (isEmpty(apiRefrow.current.grid)) return;
        if (isEmpty(rowsRef.current)) rowsRef.current = [];
        //金額セット
        for (let i = 0; i < rowsRef.current.length; i++) {
            if (isEnabled(clientchg) && columninfo.some(e => e.columnid ==="d_recv_p_row_rate")) {
                //掛率セット
                if (!isEmpty(rowsRef.current[i]["d_recv_p_row_prodno"]))
                    rowsRef.current[i]["d_recv_p_row_rate"] = CalcParam.current.rate;
            }
            if (isEnabled(priceconv)){
                if (("d_recv_p_row_currency" in rowsRef.current[i]) && ("d_recv_p_rate" in totalRef.current[0])) {
                    //単価＝レート×外貨単価　※レート、外貨単価が０の場合変更なし
                    if (NumConv(rowsRef.current[i]["d_recv_p_row_currency"] > 0 && NumConv(totalRef.current[0]["d_recv_p_rate"]) > 0)) {
                        let price = NumConv(totalRef.current[0]["d_recv_p_rate"]) * NumConv(rowsRef.current[i]["d_recv_p_row_currency"]);
                        price = GetRound(price, CalcParam.current.amtround);
                        rowsRef.current[i]["d_recv_p_row_price"] = price;
                    }
                }
            }
            //単価＝上代×掛け率
            if (columninfo.some(e => e.columnid === "d_recv_p_row_rate")) {
                if (colid=== "d_recv_p_row_retailprice" || colid === "d_recv_p_row_rate" || clientchg) {
                    if (("d_recv_p_row_retailprice" in rowsRef.current[i]) && ("d_recv_p_row_rate" in rowsRef.current[i])) {
                        let price = NumConv(rowsRef.current[i]["d_recv_p_row_retailprice"]) * (NumConv(rowsRef.current[i]["d_recv_p_row_rate"]) / 100);
                        if (price !== 0) {
                            price = GetRound(price, CalcParam.current.amtround);
                            rowsRef.current[i]["d_recv_p_row_price"] = price;
                        }
                    }
                }
            }
            let amount = NumConv(rowsRef.current[i]["d_recv_p_row_qty"]) * NumConv(rowsRef.current[i]["d_recv_p_row_price"]);
            amount = GetRound(amount, CalcParam.current.amtround);
            let taxfree = 0;
            if ("d_recv_p_row_taxfree" in rowsRef.current[i])
                taxfree = NumConv(rowsRef.current[i]["d_recv_p_row_taxfree"]);
            if (totalRef.current[0]["d_recv_p_taxkind"] === "1") {    //内税
                let intax = 0;
                if (taxfree === 0) {    //課税
                    //内税額＝税率 /（1 + 税率）* (d_recv_p_row_qty * d_recv_p_row_price)
                    intax = CalcParam.current.taxrate / (1 + CalcParam.current.taxrate) * amount;
                    intax = GetRound(intax, CalcParam.current.taxround);
                }
                rowsRef.current[i]["d_recv_p_row_intax"] = intax;
                rowsRef.current[i]["d_recv_p_row_amount"] = amount - intax;
            } else {                                                    //外税
                //金額＝数量×単価
                rowsRef.current[i]["d_recv_p_row_intax"] = 0;
                rowsRef.current[i]["d_recv_p_row_amount"] = amount;
            }
            //外貨金額＝数量×外貨単価
            let curamt = 0;
            if ("d_recv_p_row_currency" in rowsRef.current[i]) {
                curamt = NumConv(rowsRef.current[i]["d_recv_p_row_qty"]) * NumConv(rowsRef.current[i]["d_recv_p_row_currency"]);
                let col = columninfo.find(e => e.columnid === "d_recv_p_row_currency");
                if (!isEmpty(col)) {
                    curamt = GetDesitRound(curamt, CalcParam.current.amtround, col.decimalplace);
                }
            }
            rowsRef.current[i]["d_recv_p_row_currencyamt"] = curamt;

            var node = apiRefrow.current.grid.getDisplayedRowAtIndex(i);
            if (!isEmpty(node)) node.setDataValue("d_recv_p_row_amount", rowsRef.current[i]["d_recv_p_row_amount"]);
        }
        if (EmptyPanel(G_id.TOTAL)) return;
        let qty = 0;
        let amt = 0;
        let taxamt = 0;
        let tax = 0;
        let curamt = 0;
        for (let i = 0; i < rowsRef.current.length; i++) {
            let taxfree = 0;
            if ("d_recv_p_row_taxfree" in rowsRef.current[i] )
                taxfree = NumConv(rowsRef.current[i]["d_recv_p_row_taxfree"]);
            qty += NumConv(rowsRef.current[i]["d_recv_p_row_qty"]);
            amt += NumConv(rowsRef.current[i]["d_recv_p_row_amount"]);
            if (taxfree === 0) {    //課税対象分
                taxamt += NumConv(rowsRef.current[i]["d_recv_p_row_amount"]);
            }
            tax += NumConv(rowsRef.current[i]["d_recv_p_row_intax"]);
            curamt += NumConv(rowsRef.current[i]["d_recv_p_row_currencyamt"]);
        }
        totalRef.current[0]["d_recv_p_qty"] = qty;
        totalRef.current[0]["d_recv_p_amount"] = amt;
        if (totalRef.current[0]["d_recv_p_taxkind"] === "0") {    //外税
            totalRef.current[0]["d_recv_p_tax"] = GetRound(CalcParam.current.taxrate * taxamt, CalcParam.current.taxround);
        }
        if (totalRef.current[0]["d_recv_p_taxkind"] === "1") {    //内税
            totalRef.current[0]["d_recv_p_tax"] = tax;
        }
        if (totalRef.current[0]["d_recv_p_taxkind"] === "2") {    //非課税
            totalRef.current[0]["d_recv_p_tax"] = 0;
        }
        totalRef.current[0]["d_recv_p_taxinamt"] = amt + totalRef.current[0]["d_recv_p_tax"];
        totalRef.current[0]["d_recv_p_currencyamt"] = curamt;
        let rowNode = apitotal.grid.getRowNode("TOTAL");
        if(!isEmpty(rowNode)) rowNode.setData(totalRef.current[0]);
    }
    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined || panel === G_id.ROW) {
            rowsRef.current = AGRef.current.GetDatasource(apirow.grid);
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.ROW) panelid = 'rowGrid';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try {
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        } catch { }
    }
    //入力フィールドクリア
    function clearform(newform) {
        setsliplock(false);
        entrydataRef.current = initializedata(textfieldsall, staff);
        rowsRef.current = [{ rowid: RandomKey() }];
        CalcParam.current = { taxrate: 0.1, amtround: 1, taxround: 1, rate:100 };
        totalRef.current = [{ rowid: "TOTAL", grip: "計", d_recv_p_taxkind: "0" }];
        dispatch(setimagelist([]));
        imageRef.current = null;
        fileRef.current = null;
        fnc.current.modify(false);
        modifyRef.current = false;
        //列情報初期化
        colRef.current = null;
        totalcolRef.current = null;

        if (isEnabled(newform)) {
            fnc.current.getTaxrate("", (tax, taxs) => taxApply(tax, taxs, false, true));
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(textfieldsall, staff);
                        rerender();
                    },
                }, true
            )
        }

    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        AGRef.current.SaveColState(statusKey(G_id.ROW), EmptyPanel(G_id.ROW) ? null : apirow.column);
        AGRef.current.SaveColState(statusKey(G_id.TOTAL), EmptyPanel(G_id.TOTAL) ? null : apitotal.column);
        //基本情報保存
        Savestorage(corpkey, account, statusKey(G_id.BASE), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }
    function EmptyPanel(id, type) {
        try {
            let tbltype = tabletype(id);
            return isEmpty(columns.find(e => e.type === tbltype));
        } catch { return false; }
    }
    //パネル別列情報取得
    function tabletype(id) {
        if (id.substr(0, 1) === "T") {  //Total
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        } else {
            let pnl = panel.find(e => e.id === id);
            if (isEmpty(pnl)) return '';
            return pnl.type;
        }
    }

    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, statusKey(G_id.BASE));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            switch (panel[p].id) {
                case G_id.BASE:
                    if (setbase) break;
                    let fds = textfields.filter(x => !x.hide);
                    for (let f = 0; f < fds.length; f++) {
                        coldef.push({
                            headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                            type: fds[f].type
                        });
                    }
                    setbase = true;
                    break;
                case G_id.ROW:
                    cols = AGRef.current.GetshownColDef(apirow.column);
                    break;
                default:
                    continue;
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        //Total Grid
        cols = AGRef.current.GetshownColDef(apitotal.column);
        for (let i = 0; i < cols.length; i++) {
            let col = DeepCopy(cols[i]);
            col.type = tabletype(G_id.TOTAL);
            coldef.push(col);
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    var type = tabletype(G_id.ROW);
                    var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                    colRef.current = coldef;
                    type = tabletype(G_id.TOTAL);
                    coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                    totalcolRef.current = coldef;
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }
    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        for (let i = 0; i < newcol.length; i++) {
            let column = DeepCopy(textfieldsall.find(e => e.columnid === newcol[i]));
            let old = textfields.find(e => e.columnid === newcol[i]);
            if (!isEmpty(old)) column.width = old.width;    //元サイズ復元
            newfields.push(column);
        }
        settextfields(newfields);
    }

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }
    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.abbr}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} disabled={layoutlock}/>
                ))}
            </ul>
        );
    });
    function Contents(props) {
        if (props.panel.id === "0") {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.ROW) {
            return (
                <React.Fragment>
                    <EntryGrid
                        id={props.panel.id}
                        elemid="rowGrid"
                        entrydataRef={entrydataRef}
                        dataRef={rowsRef}
                        columnRef={colRef}
                        columninfo={columninfo}
                        columns={columns}
                        modifyRef={modifyRef}
                        type={tabletype(G_id.ROW)}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        statusKey={formid + "entry_" + G_id.ROW}
                        ValueChanged={ChangeRowValue}
                        RowValueChanged={RowValueChanged}
                        RemoveRow={RowDataChanged}
                        ColdefSpecial={ColdefSpecial}
                        rowDragManaged={rowDragManaged}
                        QueryRemoveRow={QueryRemoveRow}
                        QueryInsertRow={QueryInsertRow}
                    />
                    {EmptyPanel(G_id.TOTAL) ? null :
                        <EntryGrid
                            id={"T" + props.panel.id}
                            elemid="totalGrid"
                            dataRef={totalRef}
                            columnRef={totalcolRef}
                            columninfo={columninfo}
                            columns={columns}
                            type={tabletype(G_id.TOTAL)}
                            fnc={fnc}
                            onFirstDataRendered={onFirstDataRendered}
                            statusKey={formid + "entry_" + G_id.TOTAL}
                            ValueChanged={TotalValueChange}
                            total={true}
                        />
                    }
                </React.Fragment>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        return null;

    }
    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p, i) => {
                    return (
                        <Box
                            display={panelhidden(p) ? "none" : "flex"}
                            justifyContent="space-around"
                            alignItems="center"
                            padding="5px"
                        >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                            >
                                <div style={{ position: 'relative', marginBottom: 5 }}>
                                    {p.name === '' ? <div style={{ display: 'inline-block',height:10 }}></div> : p.name}
                                    {p.name2 !== '' ? '-': ''}
                                    <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                    {p.id !== '0' || layoutlock ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                            <IconButton size="small" onClick={() => SetBaseField(p.type)}  >
                                                <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                    {layoutlock || sectionclose ? null :
                                        <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                            <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                                <Icon style={{ fontSize: 16 }}>close</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                                <Contents panel={p} />
                            </Paper >
                        </Box>
                    );
                })}
            </div>
        );
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                queryaction={MenuQueryAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primaryid={'d_recv_p'}
                primarykey={primarykeys}
                parentedit={true}
                navmenu={formlock ? navmenu.filter(e => e.menuid !== 'formupload') : navmenu}
                suppressaction={suppressaction}
                lockcell={ListlockCell}
                listcellchange={ListCellChange}
                rowdatachange={ListRowChange}
                slipsave={true}
           >
                <EntryForm />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0.2,
                                m: 0,
                            }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                        >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                            />
                        </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DataTree code={edittingcode} />
            <DropZone
                code={edittingcode}
                open={isDragActive}
                onclose={FileDropClose}
                actionurl={actionurl}
                uploaded={fileuploaded}
            />
        </div>
    );
};
